export default "__VITE_ASSET__BmuXzneJ__"